import type { FaireProductEntity } from "../../entity_types/product";

export const p_x694j7aqcu: FaireProductEntity = {
  token: "p_x694j7aqcu",
  type: "product",
  name: "Scandinavia: Recipes and Ingredients",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/2bc66b976ca97ec5c1e0a13aad08a91dcf36b3b5d73a1c7a54c973a9b201ae7c.jpeg",
  galleryImageUrls: [],
  priceDollars: 14.99,
  description: "Discover the heart of Scandinavia through vibrant photographs and authentic Nordic recipes. This culinary journey takes you through Denmark, Norway, Iceland, Sweden and Finland, exploring the history, local produce, and festivals of these captivating countries. Delve into 55 enticing recipes, each thoughtfully organized by season. From classic dishes like Danish rye bread and pickled herring to mouthwatering innovations like rhubarb meringue bowls and skyr sorbet, this book captures the essence of Nordic living.",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:10.043Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
